import { Button } from "@cloudscape-design/components-themed";
import { useNavigate } from "react-router-dom";
/**
 *
 * @returns 加盟店申請（直接）情報一覧
 */
const MerchantDirectApplications = (): JSX.Element => {
  const navigate = useNavigate();
  //todo dummy実装
  return (
    <Button variant="link" onClick={() => navigate("/applications/direct/1")}>
      受付申請番号
    </Button>
  );
};

export default MerchantDirectApplications;
